// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__9sU55","selectedSolid":"Chip_selectedSolid__PY4Rm","selectedOutline":"Chip_selectedOutline__wXDcn","icon":"Chip_icon__Zmogy"};